import {
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
import "../index.css";
import http from "../services/httpService";
import handleSubmitValidation from "../utils/handleSubmitValidation";
import handleValidation from "../utils/handleValidations";
import {
  getToday,
  investmentDetailsPath,
  investmentPath,
  prospectDetailsPath,
  prospectPath,
} from "../utils/varialbles";
//import MenuItem from '@material-ui/core/MenuItem';
//import FormControl from '@material-ui/core/FormControl';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    paddingTop: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submitButton: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(10),
  },
  gridDevider: {
    marginTop: theme.spacing(6),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  lableColor: {
    color: "#393939",
  },
  select: {
    height: 36,
    minWidth: 235,
  },
  mobileCode: {
    height: 36,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },
  reviewButton: {
    borderRadius: "20px",
    border: "1px solid #2835D5",
    opacity: 1,
    textAlign: "right",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 235,
  },
  checked: {},
}));
function AddSubscription() {
  let history = useHistory();
  //const [formObject, setFromObject] = useState({});
  //(formObject);
  //const [lookupFile, setLookupFile] = useState(null);
  //(lookupFile);
  const [fname, setFname] = useState("No File Choosen");
  const [quantityDisable, setQuantityDisable] = useState(false);
  const [dateDisable, setDateDisable] = useState(false);
  const classes = useStyles();
  const location = useLocation();
  const myparam = location.state;
  // const fileInputRef = useRef(null)
  const [form, setForm] = useState({
    cust_id: "",
    firstname: "",
    lastname: "",
    state: "",
    payment_id: "",
    service_type: "",
    quantity: "",
    amount: "",
    date: "",
    proof: "",
    enddate: "",
    invlimit: "",
    gstid: "",
  });
  const {
    cust_id,
    firstname,
    lastname,
    state,
    payment_id,
    service_type,
    quantity,
    amount,
    date,
    proof,
    enddate,
    invlimit,
    gstid,
  } = form;

  const columns = [
    {
      value: "firstname",
      imp: false,
      label: "First Name",
      minWidth: 150,
      filedType: "text",
      isDisable: false,
    },

    {
      value: "lastname",
      imp: false,
      label: "Last Name",
      minWidth: 150,
      filedType: "text",
      isDisable: false,
    },

    {
      value: "state",
      imp: false,
      label: "State",
      minWidth: 150,
      filedType: "dropDown",
      isDisable: false,
    },

    {
      value: "service_type",
      imp: true,
      label: "Subscription Type",
      minWidth: 170,
      filedType: "radio",
      options: [
        { label: "Savart X Plan", value: "X" },
        { label: "Investment Requset", value: "A" },
        { label: "Investment Review", value: "R" },
        { label: "Early Renewal", value: "L" },
      ],
    },

    {
      value: "quantity",
      imp: true,
      label: "Quantity",
      minWidth: 150,
      filedType: "number",
      isDisable: true,
    },

    {
      value: "amount",
      imp: true,
      label: "Subscription Amount",
      minWidth: 150,
      filedType: "number",
    },

    {
      value: "date",
      imp: true,
      label: "Subscription Date",
      minWidth: 150,
      filedType: "date",
    },

    // { "value": 'discount_type', "imp": true, "label": 'Payment Id', minWidth: 150, "filedType": "radio", "options": [{ "label": "Custom", "value": "Custom" }, { "label": "Student", "value": "Student" }, { "label": "Farmer", "value": "Farmer" }, { "label": "Milltary", "value": "Milltary" }, { "label": "Micro-Investor", "value": "Micro-Investor" }] },

    {
      value: "payment_id",
      imp: true,
      label: "Payment Id",
      minWidth: 150,
      filedType: "text",
    },

    {
      value: "proof",
      imp: true,
      label: "Subscription proof",
      minWidth: 150,
      filedType: "file",
    },

    // { "value": 'reason', "imp": true, "label": 'Reason', minWidth: 150, "filedType": "textarea", multiline: true, rows: 5 },
  ];
  // const validations = {

  //     "service_type": {
  //         conditions: {
  //             "required": true
  //         }, "message": "This Field is required!", "valid": true, "changed": false
  //     },
  //     "quantity": {
  //         conditions: {
  //             "required": true,"minValue":1
  //         }, "message": "This Field is required!", "valid": true, "changed": false
  //     },
  //     "reason": {
  //         conditions: {
  //             "required": true, "maxLength": 1000
  //         }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
  //     },
  //     "date": {
  //         conditions: {
  //             "required": true,"minDate":getToday(),"pattren":/^\d{4}-\d{2}-\d{2}$/
  //         }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
  //     },
  //     "amount": {
  //         conditions: {
  //             "required": true, "minValue": 10,
  //         }, "message": "Maximum 20 character Allowed.!", "valid": true, "changed": false
  //     },
  //     "proof": {
  //         conditions: {
  //             "required": true
  //         }, "message": "Proof is required!", "valid": true, "changed": false
  //     },
  //     "state": {
  //         conditions: {
  //             "required": true
  //         }, "message": "state is required!", "valid": false, "changed": false
  //     },
  // }
  //const [validationState, setValidationState] = useState(validations)
  const gotoProspectDetails = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: prospectDetailsPath,
        state: myparam,
      });
    } else if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentDetailsPath,
        state: myparam,
      });
    }
  };

  // useEffect(() => {
  //     if (myparam && (myparam.cust__id || myparam.customer_id)) {
  //         //setFromObject(form)
  //     }
  //      else {
  //         //gotoProspectDetails()
  //     }

  // }, [])

  const [servicePlans, setServicePlans] = useState([]);

  useEffect(() => {
    if (location.state === undefined || location.state === null) {
      gotoProspectDetails();
      //(location);
      //alert('undefined');
    } else {
      var custid = "";
      if (location.state.cust__id) {
        custid = location.state.cust__id;
        http
          .get(`/customerPersonalProfileStatus?cust_id=${custid}`)
          .then((res) => {
            //(res);

            if (res.data.Data === "C") {
              setShowfields(false);
            } else if (res.data.Data === "P") {
              setShowfields(true);
            }
            //setShowStateList(res.data.Data);
          })
          .catch((err) => {
            console.log("error");
          });

        http
          .get(`/subscription_options?cust_id=${custid}`)
          .then((res) => {
            setServicePlans(res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (location.state.customer_id) {
        custid = location.state.customer_id;
        http
          .get(`/customerPersonalProfileStatus?cust_id=${custid}`)
          .then((res) => {
            //(res);

            if (res.data.Data === "C") {
              setShowfields(false);
            } else if (res.data.Data === "P") {
              setShowfields(true);
            }
            //setShowStateList(res.data.Data);
          })
          .catch((error) => {
            console.log("error");
          });

        http
          .get(`/subscription_options?cust_id=${custid}`)
          .then((res) => {
            setServicePlans(res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }

      setForm({
        ...form,
        cust_id: custid,
      });
    }
  }, []);
  const formData = new FormData();

  // const handleChange = (event) => {
  //   setForm({ ...form, [event.target.name]: event.target.value });

  //   if (event.target.name === "service_type" && event.target.value === "X") {
  //     setQuantityDisable(true);
  //     setForm({
  //       ...form,
  //       quantity: "1",
  //       service_type: "X",
  //     });
  //     //isSavartX = true;
  //   } else if (
  //     event.target.name === "service_type" &&
  //     event.target.value === "T"
  //   ) {
  //     setQuantityDisable(true);
  //     setForm({
  //       ...form,
  //       quantity: "1",
  //       service_type: "T",
  //     });
  //     //isSavartX = true;
  //   } else if (
  //     event.target.name === "service_type" &&
  //     event.target.value === "SAUAT"
  //   ) {
  //     setQuantityDisable(true);
  //     setForm({
  //       ...form,
  //       quantity: "1",
  //       service_type: "SAUAT",
  //     });
  //   } else if (
  //     event.target.name === "service_type" &&
  //     event.target.value === "SPMST"
  //   ) {
  //     setQuantityDisable(true);
  //     setForm({
  //       ...form,
  //       quantity: "1",
  //       service_type: "SPMST",
  //     });
  //   } else if (
  //     event.target.name === "service_type" &&
  //     (event.target.value === "A" || event.target.value === "R")
  //   ) {
  //     setQuantityDisable(false);
  //     setDateDisable(false);
  //   }
  //   if (
  //     (event.target.name === "service_type" && event.target.value === "L") ||
  //     (event.target.name === "service_type" && event.target.value === "U") ||
  //     (event.target.name === "service_type" && event.target.value === "LX3")
  //   ) {
  //     let type;
  //     if (event.target.value === "LX3") {
  //       type = "X3";
  //     } else {
  //       type = event.target.value;
  //     }
  //     http
  //       .get(
  //         `/getLateRenewalData?cust_id=${cust_id}&service_type=${type}`,
  //         form
  //       )
  //       .then((res) => {
  //         // (res);
  //         if (res.data.statusCode === 1) {
  //           toast.error(
  //             res.data.error +
  //               " Please Choose Different Service Type OR Contact Your CDT"
  //           );
  //           setForm({
  //             ...form,
  //             service_type: "",
  //           });
  //           setDateDisable(false);
  //         }
  //         let stype;
  //         if (event.target.value === "L") {
  //           stype = "L";
  //         } else if (event.target.value === "U") {
  //           stype = "U";
  //         } else if (event.target.value === "LX3") {
  //           stype = "LX3";
  //         }
  //         if (res.data.statusCode === 0) {
  //           // (res.data.Data);
  //           setForm({
  //             ...form,
  //             service_type: stype,
  //             date: res.data.Data,
  //             quantity: "1",
  //           });
  //           setDateDisable(true);
  //           setQuantityDisable(true);
  //           // toast.success(res.data.Data);
  //         }
  //       })
  //       .catch((err) => {
  //         // (err);
  //         console.log("error");
  //       });
  //   }
  //   // else if (event.target.name === "service_type" && event.target.value !== "L") {
  //   //     setForm({
  //   //         ...form,
  //   //         service_type: ""
  //   //     });
  //   //     setDateDisable(false);
  //   // }
  // };
  const [newFields, setNewFields] = useState(false);
  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
    if (event.target.name === "service_type") {
      // This is to fetch the upgrade amount
      console.log(event.target.value.includes("U"), "includes");
      if (event.target.value.includes("U")) {
        formData.append("cust_id", location.state.customer_id);
        formData.append("service_type", event.target.value);
        http
          .post(`/upgradecost`, formData)
          .then((res) => {
            // if (event.target.value === "UT+") {
            setForm({
              ...form,
              amount: Math.round(res.data.amount),
              service_type: event.target.value,
            });
            // }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (event.target.value === "X") {
        setQuantityDisable(true);
        setForm({
          ...form,
          quantity: "1",
          service_type: event.target.value,
        });
      } else if (
        event.target.name === "service_type" &&
        event.target.value === "T"
      ) {
        setQuantityDisable(true);
        setForm({
          ...form,
          quantity: "1",
          service_type: "T",
        });
      } else if (
        event.target.value === "L" ||
        event.target.value === "UT+" ||
        event.target.value === "LX3"
      ) {
        let type;

        http
          .get(
            `/getLateRenewalData?cust_id=${cust_id}&service_type=${type}`,
            form
          )
          .then((res) => {
            // (res);
            if (res.data.statusCode === 1) {
              toast.error(
                res.data.error +
                  " Please Choose Different Service Type OR Contact Your CDT"
              );
              setForm({
                ...form,
                service_type: "",
              });
              setDateDisable(false);
            }
            let stype;
            if (event.target.value === "L") {
              stype = "L";
            } else if (event.target.value === "UT+") {
              stype = "UT+";
            } else if (event.target.value === "LX3") {
              stype = "LX3";
            }
            if (res.data.statusCode === 0) {
              setForm({
                ...form,
                service_type: stype,
                date: res.data.Data,
                quantity: "1",
              });
              setDateDisable(true);
              setQuantityDisable(true);
            }
          })
          .catch((err) => {
            console.log("error");
          });
      } else {
        setDateDisable(false);
        setForm({
          ...form,
          amount: "",
          quantity: "",
          service_type: event.target.value,
          date: "",
        });
      }
      if (
        event.target.value === "SPIA" ||
        event.target.value === "SWP" ||
        event.target.value === "SPMS" ||
        event.target.value === "X+" ||
        event.target.value === "T+" || 
        event.target.value === "UT+" ||
        event.target.value === "UX+"
      ) {
        setNewFields(true);
      } else if (
        event.target.value !== "SPIA" ||
        event.target.value !== "SWP" ||
        event.target.value === "SPMS" ||
        event.target.value !== "X+" ||
        event.target.value !== "T+" || 
        event.target.value !== "UX+" ||
        event.target.value !== "UT+"
      ) {
        setNewFields(false);
      }
    }
  };

  const [baseImage, setBaseImage] = useState("");

  // const handleFileChange = async (event) => {
  //     //alert("file received");
  //     const file = event.target.files[0];
  //     setBaseImage(file);

  //     const base64 = await convertBase64(file);

  //     //   setBaseImage(base64);
  //     setForm({ ...form, proof: event.target.files[0] });
  // }

  const [image, setImage] = useState([]);

  let data = new FormData();
  data.append("image", image);

  const handleFileChange = (event) => {
    setFname(event.target.files[0].name);
    // setImage(event.target.files[0]);
    // setForm({ ...form, proof:URL.createObjectURL(event.target.files[0])});

    let reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);

    reader.onload = () => {
      setForm({ ...form, proof: reader.result });
    };
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  // const imgBase = {
  //     file: baseImage,
  //   };

  // const postData={
  //     cust_id:cust_id,
  //     firstname:firstname,
  //     lastname:lastname,
  //     state:state,
  //     payment_id:payment_id,
  //     service_type:service_type,
  //     quantity:quantity,
  //     amount:amount,
  //     date:date,
  //     proof:proof
  // }
  // (postData);

  const handleSubmit = (event) => {
    //let customer_id = myparam.cust__id || myparam.customer_id;
    //setForm({...form, cust_id:customer_id});

    if (showfields === true) {
      // quantity === "" ||
      if (
        firstname === "" ||
        lastname === "" ||
        state === "" ||
        payment_id === "" ||
        service_type === "" ||
        amount === "" ||
        date === "" ||
        proof === "" ||
        (service_type &&
          ((service_type === "SPIA" && (invlimit === "" || enddate === "")) ||
            (service_type === "SWP" && (invlimit === "" || enddate === "")) ||
            (service_type === "SPMS" && enddate === "")))
      ) {
        toast.error("Please fill all the fields");
      } if((service_type === "X+" || service_type === "T+" || service_type === "UT+" || service_type === "UX+") && Number(invlimit) < 600000){
        toast.error("Investment limit should be minimum of 600000");
      }
      else {
        http
          .post("/addSubscription", form)
          .then((res) => {
            if (res.data.statusCode === 1) {
              toast.error(res.data.error);
            }
            if (res.data.statusCode === 0) {
              toast.success(res.data.Data);
              if (myparam.cust__id) {
                history.push({
                  pathname: prospectPath,
                  state: { tab: "Overview" },
                });
              } else if (myparam.customer_id) {
                history.push({
                  pathname: investmentPath,
                  state: { tab: "Overview" },
                });
              }
            }
          })
          .catch((error) => {
            console.log("error");
          });
      }
    } else if (showfields === false) {
      // quantity === "" ||
      if (
        payment_id === "" ||
        service_type === "" ||
        amount === "" ||
        date === "" ||
        proof === "" ||
        (service_type &&
          ((service_type === "SPIA" && (invlimit === "" || enddate === "")) ||
            (service_type === "SWP" && (invlimit === "" || enddate === "")) ||
            (service_type === "SPMS" && enddate === "")))
      ) {
        console.log(service_type, "service_type");
        toast.error("Please fill all the fields");
      } else {
        http
          .post("/addSubscription", form)
          .then((res) => {
            if (res.data.statusCode === 1) {
              toast.error(res.data.error);
            }
            if (res.data.statusCode === 0) {
              toast.success(res.data.Data);
              if (myparam.cust__id) {
                history.push({
                  pathname: prospectPath,
                  state: { tab: "Overview" },
                });
              } else if (myparam.customer_id) {
                history.push({
                  pathname: investmentPath,
                  state: { tab: "Overview" },
                });
              }
            }
          })
          .catch((error) => {
            console.log("error");
          });
      }
    }
    //alert("submitted");
    // else{
    // }
  };

  const [showsSatesList, setShowStateList] = useState([]);
  //(showsSatesList);
  useEffect(() => {
    http
      .get("/statesList")
      .then((res) => {
        //(res);
        //(res.data.Data);
        setShowStateList(res.data.Data);
      })
      .catch((err) => {});
  }, []);
  const [showfields, setShowfields] = useState(false);

  // useEffect(()=>{
  //     let cid = cust_id;
  //     http.get(`/customerPersonalProfileStatus?cust_id=${cid}`).then(res=>{
  //         //(res);
  //         (res.data.Data);
  //         if(res.data.Data === "C"){
  //             setShowfields(false);
  //         }
  //         else if(res.data.Data === "P"){
  //             setShowfields(true);
  //         }
  //         //setShowStateList(res.data.Data);
  //     }).catch(err=>{
  //         (err);
  //     });
  // },[]);

  return (
    <Grid xs={12} container component="main">
      <Grid container style={{ marginBottom: "50px" }}>
        <Grid item xs={12} sm={5} md={5}>
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            onClick={gotoProspectDetails}
          >
            Back
          </Button>
        </Grid>
        <Grid item xs={12} sm={5} md={5} className="mt30">
          <Typography color="textPrimary" variant="h4" fontWeight="700">
            Add Subscription
          </Typography>
        </Grid>
      </Grid>
      <Grid container style={{ marginBottom: "30px" }}>
        <Grid
          container
          style={{
            justifyContent: "space-between",
            marginBottom: "15px",
            alignItems: "center",
          }}
        >
          {showfields ? (
            <>
              <Grid item>
                <InputLabel style={{ marginBottom: "15px" }}>
                  First Name <span style={{ color: "red" }}>&#42;</span>
                </InputLabel>
                <TextField
                  margin="dense"
                  label="Enter"
                  variant="outlined"
                  value={firstname}
                  name="firstname"
                  onChange={handleChange}
                  style={{ width: "300px" }}
                />
              </Grid>
              <Grid item>
                <InputLabel style={{ marginBottom: "15px" }}>
                  Last Name <span style={{ color: "red" }}>&#42;</span>
                </InputLabel>
                <TextField
                  margin="dense"
                  label="Enter"
                  variant="outlined"
                  value={lastname}
                  name="lastname"
                  onChange={handleChange}
                  style={{ width: "300px" }}
                />
              </Grid>
              <Grid item>
                <InputLabel style={{ marginBottom: "20px" }}>
                  State <span style={{ color: "red" }}>&#42;</span>
                </InputLabel>

                <TextField
                  label="Select"
                  variant="outlined"
                  id="service_types"
                  select
                  value={state}
                  name="state"
                  onChange={handleChange}
                  size="small"
                  style={{ width: "300px" }}
                >
                  {showsSatesList.map((item) => (
                    <MenuItem value={item}>{item}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            </>
          ) : (
            ""
          )}
        </Grid>
        <Grid
          container
          style={{ justifyContent: "space-between", marginBottom: "15px" }}
        >
          <Grid item>
            <InputLabel style={{ marginBottom: "20px" }}>
              Service type <span style={{ color: "red" }}>&#42;</span>
            </InputLabel>
            <FormControl variant="outlined">
              {/* <InputLabel id="state">State</InputLabel> */}

              <TextField
                label="Select"
                variant="outlined"
                id="service_types"
                select
                value={service_type}
                name="service_type"
                onChange={handleChange}
                size="small"
                style={{ width: "300px" }}
              >
                {/* <MenuItem value="X">Savart X</MenuItem>
                <MenuItem value="A">Investment Request</MenuItem>
                <MenuItem value="R">Investment Review</MenuItem>
                <MenuItem value="L">Early Renewal SavartX</MenuItem>
                <MenuItem value="LX3">Early Renewal SavartX3</MenuItem>
                <MenuItem value="T">SavartX3</MenuItem>
                <MenuItem value="U">Upgrade</MenuItem>
                <MenuItem value="SAUAT">PIA</MenuItem>
                <MenuItem value="SPMST">PMS</MenuItem> */}
                {servicePlans.map((item) => {
                  return <MenuItem value={item.value}>{item.name}</MenuItem>;
                })}
              </TextField>
            </FormControl>
          </Grid>
          {/* <Grid item>
            <InputLabel style={{ marginBottom: "15px" }}>
              Quantity <span style={{ color: "red" }}>&#42;</span>
            </InputLabel>
            <TextField
              margin="dense"
              label="Enter"
              variant="outlined"
              value={quantity}
              name="quantity"
              onChange={handleChange}
              style={{ width: "300px" }}
              type="number"
              disabled={quantityDisable ? "disabled" : ""}
            />
          </Grid> */}

          <Grid item>
            <InputLabel style={{ marginBottom: "15px" }}>GST ID</InputLabel>
            <TextField
              margin="dense"
              label="Enter"
              variant="outlined"
              value={gstid}
              name="gstid"
              onChange={handleChange}
              style={{ width: "300px" }}
            />
          </Grid>
          <Grid item>
            <InputLabel style={{ marginBottom: "15px" }}>
              Subscription Amount <span style={{ color: "red" }}>&#42;</span>
            </InputLabel>
            <TextField
              margin="dense"
              label="Enter"
              variant="outlined"
              value={amount}
              name="amount"
              onChange={handleChange}
              style={{ width: "300px" }}
              type="number"
            />
          </Grid>
        </Grid>

        <Grid
          container
          style={{
            justifyContent: "space-between",
            marginBottom: 20,
            textAlign: "left",
          }}
        >
          <Grid item>
            <InputLabel style={{ marginBottom: "15px" }}>
              Subscription Date <span style={{ color: "red" }}>&#42;</span>
            </InputLabel>
            <TextField
              margin="dense"
              variant="outlined"
              disabled={dateDisable ? true : false}
              value={date}
              name="date"
              onChange={handleChange}
              style={{ width: "300px" }}
              type="date"
            />
          </Grid>

          <Grid item>
            <InputLabel style={{ marginBottom: "15px" }}>
              Payment Id <span style={{ color: "red" }}>&#42;</span>
            </InputLabel>
            <TextField
              margin="dense"
              label="Enter"
              variant="outlined"
              value={payment_id}
              name="payment_id"
              onChange={handleChange}
              style={{ width: "300px" }}
              type="text"
            />
          </Grid>
          <Grid item style={{ width: "300px" }}>
            <InputLabel style={{ marginBottom: "28px" }}>
              Subscription Proof <span style={{ color: "red" }}>&#42;</span>
            </InputLabel>
            <Button variant="contained" component="label" size="small">
              Upload
              <input
                hidden
                id="file"
                type="file"
                onChange={(e) => {
                  handleFileChange(e);
                }}
                // onChange={e => setImage(e.target.value)}
                // style={{ display: "none" }}
                multiple={false}
                accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
              />
            </Button>
            <span style={{ marginLeft: "10px", fontWeight: "300" }}>
              {fname}
            </span>
            {/* <img src={proof} /> */}
          </Grid>

          {/* <Grid item>
              <InputLabel style={{ marginBottom: "15px" }}>
                GST ID <span style={{ color: "red" }}>&#42;</span>
              </InputLabel>
              <TextField
                margin="dense"
                label="Enter"
                variant="outlined"
                value={gstid}
                name="gstid"
                onChange={handleChange}
                style={{ width: "300px" }}
                type="number"
                disabled={quantityDisable ? "disabled" : ""}
              />
            </Grid>{" "} */}
        </Grid>

        <Grid
          container
          style={{
            justifyContent: "space-between",

            textAlign: "left",
          }}
        >
          {newFields && (service_type === "SPIA" || service_type === "SWP" || service_type === "SPMS") && (
            <Grid item>
              <InputLabel style={{ marginBottom: "15px" }}>
                Expiry Date <span style={{ color: "red" }}>&#42;</span>
              </InputLabel>
              <TextField
                margin="dense"
                label=""
                variant="outlined"
                value={enddate}
                name="enddate"
                onChange={handleChange}
                style={{ width: "300px" }}
                type="date"
                disabled={quantityDisable ? "disabled" : ""}
              />
            </Grid>
          )}
          {newFields && (service_type === "SPIA" || service_type === "SWP" || service_type === "X+" || service_type === "T+" || service_type === "UT+" || service_type === "UX+") && (
            <Grid item>
              <InputLabel style={{ marginBottom: "15px" }}>
                Investment Limit <span style={{ color: "red" }}>&#42;</span>
              </InputLabel>
              <TextField
                margin="dense"
                label="Enter"
                variant="outlined"
                value={invlimit}
                name="invlimit"
                onChange={handleChange}
                style={{ width: "300px" }}
                type="number"
                disabled={quantityDisable ? "disabled" : ""}
              />
            </Grid>
          )}{" "}
          <Grid item></Grid>
          <Grid item></Grid>
          <Grid item></Grid>
        </Grid>
      </Grid>

      {/* <Grid>
        <Grid item>
        <InputLabel style={{ marginBottom: "15px" }}>
                  GST
                </InputLabel>
                <TextField
                  margin="dense"
                  label="Enter"
                  variant="outlined"
                  value={gst}
                  name="gst"
                  onChange={handleChange}
                  style={{ width: "300px" }}
                />
        </Grid>
      </Grid> */}
      <Grid container style={{ justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          style={{ width: "100px" }}
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  );
}

export default AddSubscription;
